import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { connect } from 'react-redux'
import { FormattedDate } from 'components/intl'
import { compose } from 'recompose'
import { Modal } from 'containers/misc'
import { ContactRemove, ContactSettings } from 'containers/forms/contacts'
import { FormData, Module, Status } from 'components/misc'
import { apiAssessors, apiCodeLists } from 'helpers/decorators/api'
import { getActiveRole } from 'utils/token'
import { filterByRole } from 'redux/selectors/misc'
import { ASSESSOR_WWC_STATE_TYPES, REMOVE_CONTACT_TYPES } from '../../../../constants/enums'
import { FormattedMessage } from 'react-intl'
import RevokeAccess from '../../../../containers/forms/contacts/RevokeAccess/RevokeAccess'

const enhance = compose(
  connect(({ auth, api }) => ({
    activeOrganization: auth.organization,
    isLoading: get(api, 'assessors.overview.loading')
  })),
  apiCodeLists(['personStates']),
  apiAssessors()
)

class AssessorOverview extends Component {
  static propTypes = {
    overviewData: PropTypes.object,
    assessorData: PropTypes.list,
    activeOrganization: PropTypes.object.isRequired,
    codeLists: PropTypes.object.isRequired,
    deleteAssessor: PropTypes.func.isRequired,
    changePersonState: PropTypes.func.isRequired,
    orgContactDeletionTypes: PropTypes.array,
    modal: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired
  }

  static defaultProps = {
    data: {}
  }

  render () {
    const {
      overviewData,
      assessorData,
      orgContactDeletionTypes,
      activeOrganization,
      codeLists
    } = this.props

    const role = getActiveRole(activeOrganization)

    const actions = [
      {
        id: 1,
        label: 'Revoke access',
        intlKey: 'contact.revoke_access',
        onClick: () => this.props.modal('assessor-revoke-access')
      },
      {
        id: 2,
        label: 'Change status',
        intlKey: 'contact.change_contact_status',
        onClick: () => this.props.modal('contact-status-change')
      },
      {
        id: 3,
        label: 'Delete account',
        intlKey: 'participant.delete_account',
        onClick: () => this.props.modal('assessor-account-remove'),
        negative: true
      }
    ]

    const actionsByRole = filterByRole(actions, role)

    const assessorCount = assessorData && assessorData.length

    return (
      <div>
        <Module
          primary
          grid
          title="Overview"
          intlKey="moduleTitle.overview"
          actionDropdown="Account Settings"
          actionDropdownActions={actionsByRole}
        >

          <div className="row">
            <div className="col-xs-3">
              <FormData label="Activation date" intlKey="label.activation_date">
                {get(overviewData, 'assessorWWC.createdAt') &&
                  <FormattedDate value={get(overviewData, 'assessorWWC.createdAt')} />}
              </FormData>
            </div>
            <div className="col-xs-3">
              <FormData label="State" intlKey="label.state">
                <Status state={get(overviewData, 'person.personState')} />
              </FormData>
            </div>
          </div>
          {assessorData.map(({ assessorWWC, organization }) => (
            <div>
              {assessorCount > 1 && <div className="row">
                <div className="col-xs-9">
                  <FormData label="Organization" intlKey="label.organization">
                    {get(organization, 'name')}
                  </FormData>
                </div>
              </div>}
              <div className="row">
                <div className="col-xs-3">
                  <FormData label="WWC number" intlKey="label.wwc_number">
                    {!get(assessorWWC, 'childProtectionNumber') && '---'}

                    {get(assessorWWC, 'childProtectionNumber') &&
                      <span>{get(assessorWWC, 'childProtectionNumber')}</span>}

                  </FormData>
                </div>
                <div className="col-xs-3">
                  <FormData label="WWC expired" intlKey="label.wwc_expired">
                    {get(assessorWWC, 'state.value') === ASSESSOR_WWC_STATE_TYPES.exempted.id && <FormattedMessage
                      id="label.wwc_is_exempted"
                      defaultMessage="Exempted"
                    />}

                    {get(assessorWWC, 'childProtectionExpirationDate') &&
                      <FormattedDate
                        value={get(assessorWWC, 'childProtectionExpirationDate')}
                      />}
                  </FormData>
                </div>
                <div className="col-xs-3">
                  { get(assessorWWC, 'assessorWWCExemptionReason') && <FormData label="Exemption reason" intlKey="label.exemption_reason">
                    {get(assessorWWC, 'assessorWWCExemptionReason')}
                  </FormData>}
                </div>
              </div>
            </div>
          ))}


        </Module>
        <Modal id="assessor-revoke-access" enableOverflow customActions>
          <RevokeAccess
            onRevokeAccess={this.props.onRevokeAccess}
            data={overviewData}
          />
        </Modal>
        <Modal id="assessor-account-remove" enableOverflow customActions>
          <ContactRemove
            onDelete={this.props.deleteAssessor}
            reasonsList={orgContactDeletionTypes}
            selectContactFrom={get(overviewData, 'organizationContacts', [])}
            contactRemoveType={REMOVE_CONTACT_TYPES.ASSESSOR.value}
            id={get(overviewData, 'id')}
          />
        </Modal>
        <Modal id="contact-status-change" compact customActions>
          <ContactSettings
            data={overviewData}
            personStates={codeLists.personStates.list}
            changePersonState={this.props.changePersonState}
          />
        </Modal>
      </div>
    )
  }
}

export default enhance(AssessorOverview)
